export default {
    topbar: { delivery: "Fast local delivery • HE / EN / TH", support: "Support", orders: "Orders", about: "About" },
    header: {
        searchPlaceholder: "Search products, brands, categories…",
        language: "Language",
        notifications: "Notifications",
        hello: "Hello",
        account: "Account",
        signIn: "Sign In",
        signUp: "Sign Up",
        shoppingCart: "Shopping Cart",
        myOrders: "My Orders",
        settings: "Settings",
        signOut: "Sign Out",
        theme: "Theme",
        dark: "Dark",
        light: "Light",
        darkTheme: "Dark Theme",
        lightTheme: "Light Theme",
        cartItems: "{{count}} items"
    },
    filters: {
        discover: "Discover", realProducts: "Products", newArrivals: "New Arrivals",
        reorder: "Ready to Reorder", thaiProducts: "Thai Products", drinks: "Drinks", snacks: "Snacks", offers: "Special Offers"
    },
    mobileNav: { home: "Home", categories: "Categories", search: "Search", menu: "Menu", cart: "Cart" },
    sidebar: {
        title: "Shop categories", subtitle: "Everything stays one tap away", discover: "Discover", homePage: "Home Page",
        beverages: "Beverages", instantFood: "Instant Food", riceNoodles: "Rice & Noodles", snacks: "Snacks",
        household: "Household", personalCare: "Personal Care", deals: "Deals",
        promoTitle: "Quick repeat shopping", promoText: "Bring back frequent items faster and reduce friction for returning customers.",
        subcategories: {
            coffeeTea: "Coffee & Tea", milkPowder: "Milk Powder", softDrinks: "Soft Drinks",
            noodles: "Noodles", soups: "Soups", readyMeals: "Ready Meals", rice: "Rice", saucesSeasoning: "Sauces & Seasoning",
            cookies: "Cookies", chips: "Chips", sweets: "Sweets", cleaning: "Cleaning", laundry: "Laundry", paperGoods: "Paper Goods",
            soapShampoo: "Soap & Shampoo", dentalCare: "Dental Care", dailyEssentials: "Daily Essentials"
        }
    }
} as const;
